module.exports = __webpack_public_path__ + "img/germany.5dbd4e58.svg";